import React from 'react'
import { Tab as MuiTab, TabProps } from '@mui/material'

interface PropsType extends TabProps {}

export const Tab = (props: PropsType) => {
	return <MuiTab {...props} />
}
